module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Zernez_neu-0b17c8046141d2170b070eeb38edd3c1.png";